import { Box, styled } from '@material-ui/core';
import { Pricing, Product, ProductColumnsIds } from '@setvi/shared/interfaces';
import { Skeleton } from '@material-ui/lab';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { getProductDetailsPricing } from 'componentsV2/product/product-details/content/components/product-showcase/components/full-price/pricing';

export const pricingDependsOnCustomer = [
  ProductColumnsIds.Price,
  ProductColumnsIds.CustomerCost,
  ProductColumnsIds.GP,
  ProductColumnsIds.Discount
];

const Wrapper = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: theme.spacing(2)
}));

const Bullet = styled('span')({
  lineHeight: '24px',
  fontSize: 18,
  margin: '0 2px',
  transform: 'translateY(-1px)'
});

interface SingerAmountsProps {
  product: Product;
  filterActive: boolean;
  onGetPrice: any;
  loading?: boolean;
  pricing: Pricing[];
}

export const FullPrice = ({
  product,
  loading: priceLoading = false,
  filterActive,
  onGetPrice,
  pricing
}: SingerAmountsProps) => {
  const shouldAutoLoadPrice = useMemo(
    () => product?.price === null && filterActive,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [filterActive]
  );
  const [loading, setLoading] = useState(shouldAutoLoadPrice || priceLoading);

  const filteredPricing = filterActive
    ? pricing
    : pricing?.filter(i => !pricingDependsOnCustomer.includes(i.id));

  const handleGetPrice = useCallback(async () => {
    setLoading(true);
    try {
      await onGetPrice();
    } finally {
      setLoading(false);
    }
  }, [onGetPrice]);

  useEffect(() => {
    shouldAutoLoadPrice && handleGetPrice();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldAutoLoadPrice]);

  if (!filteredPricing.length) return null;

  if (loading)
    return (
      <Wrapper>
        <Skeleton variant="rect" height={20} width={150} />
        <Skeleton variant="rect" height={20} width={200} />
        <Skeleton variant="rect" height={20} width={150} />
      </Wrapper>
    );

  return (
    <Wrapper>
      {filteredPricing.map((i, index) => (
        <>
          {getProductDetailsPricing({ pricing: i, product })}
          {index !== filteredPricing?.length - 1 && <Bullet>•</Bullet>}
        </>
      ))}
    </Wrapper>
  );
};
